import React from 'react';
import { styled } from '@mui/material/styles';

import RawHelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Banniere from '../../graphic-charter/illustrations/door.png';
import { SingleLineText } from '../atoms/SingleLineText';
import { Logo as RawLogo } from '../atoms/Logo';
import { Title } from '../atoms/Title';

type FallbackErrorProps = {
  errorText?: string;
  errorCode?: string;
  hideRedirection?: boolean;
};

const FallbackError = ({ errorText, errorCode, hideRedirection = false }: FallbackErrorProps) => {
  return (
    <ContainerDiv>
      {errorCode === 'UNKNOWN_BLOOMER' ? (
        <>
          <Title span="Salut l'inconnu.e !" />
          <HelpOutlineIcon />
        </>
      ) : errorCode && errorCode === '404' ? (
        <Title span="404 ! 🧐" />
      ) : errorCode && errorCode === '403' ? (
        <Title span="Stop ! 🛑" />
      ) : (
        <Title span="Oups ! 😵" />
      )}
      <SingleLineText
        text={errorText ? errorText : 'Désolé mais une erreur est survenue, nos agents sont sur le coup !'}
      />
      <ContainerMailTo>
        <SingleLineText text="Pour nous contacter: " />
        <br />
        <br />
      </ContainerMailTo>
      <a href="mailto:bloomhelp@bloomays.com">bloomhelp@bloomays.com</a>
      <br />
      {!hideRedirection && (
        <RedirectionContainer>
          <SingleLineText text={"Retour à la page d'accueil 👉"} />
          <a href="/">ici</a>
        </RedirectionContainer>
      )}
      <Logo image={Banniere} alt="error fallback banniere" />
    </ContainerDiv>
  );
};

export default FallbackError;
export { FallbackError };

const ContainerMailTo = styled('div')(() => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'center',
  alignItems: 'center',
}));

const ContainerDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  backgroundColor: theme.palette.neutral.white,
  boxShadow: '2px 2px 20px lightgrey',
  borderRadius: '10px',
  width: '40%',
  margin: '1em auto',
  padding: '1em',
  alignItems: 'center',
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    width: '80%',
  },
}));

const RedirectionContainer = styled('div')(() => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'center',
  alignItems: 'center',
}));

const Logo = styled(RawLogo)(() => ({
  paddingTop: '2em',
  width: '100%',
}));

const HelpOutlineIcon = styled(RawHelpOutlineIcon)(({ theme }) => ({
  color: theme.palette.blue[60],
  fontSize: '130px !important',
  margin: 'auto',
}));
